import * as React from 'react';



export default class ToastMessage extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" fillRule="evenodd">
            <g>
                <g transform="translate(-375.000000, -718.000000) translate(375.000000, 718.000000)">
                    <circle cx="12" cy="12" r="10" stroke="#F5A623"/>
                    <text fill="#F5A623" fontFamily="ProximaNova-Regular, Proxima Nova" fontSize="14">
                        <tspan x="10" y="17">!</tspan>
                    </text>
                </g>
            </g>
        </g>
      </svg>
    )
  }
}
